module.exports = __webpack_public_path__ + "static/img/20.71fe9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/20.jpg
// module id = RH4k
// module chunks = 0